import React, { useEffect, useMemo, useState } from 'react';
import { UIStateProps, uiState } from '../../atoms/uiAtom';

import { ReactComponent as CloseIcon } from '../../assets/close.svg';
import Container from './Container';
import classNames from 'classnames';
import { createPortal } from 'react-dom';
import { useOutsideClick } from '../../hooks/domManipulations';
import { useRecoilValue } from 'recoil';

export interface BottomSheetProps {
  isOpen: boolean;
  title?: string;
  children: JSX.Element | JSX.Element[] | string | boolean;
  actions?: JSX.Element | JSX.Element[] | string | boolean;
  onClose: () => void;
}
export default function BottomSheet({
  title,
  isOpen,
  onClose,
  children,
  actions,
}: BottomSheetProps) {
  const [wrapper, setSetWrapper] = useState<Element>();
  const ui = useRecoilValue<UIStateProps>(uiState);
  useOutsideClick(document.getElementsByClassName('bottom-sheet')[0], isOpen, onClose);

  const calculateTop = useMemo(() => {
    if (ui.hasError || ui.hasWarning) {
      return 136;
    } else if (ui.hasError && ui.hasWarning) {
      return 192;
    } else {
      return 80;
    }
  }, [ui.hasError, ui.hasWarning]);
  useEffect(() => {
    const wrapper = document.getElementsByClassName('bottom-sheet-portal')[0];
    if (!wrapper) {
      const element = document.createElement('div');
      element.className = `bottom-sheet-portal ${isOpen ? 'bottom-sheet-portal--open' : ''}`;
      element.setAttribute('data-test-id', 'bottom-sheet-portal');
      element.style.top = `${calculateTop}px`;
      document.body.appendChild(element);
      setSetWrapper(element);
    } else {
      wrapper.className = `bottom-sheet-portal ${isOpen ? 'bottom-sheet-portal--open' : ''}`;
      wrapper.setAttribute('data-test-id', 'bottom-sheet-portal');
      (wrapper as any).style.top = `${calculateTop}px`;
      setSetWrapper(wrapper);
    }
  }, [calculateTop, isOpen, onClose, wrapper]);

  return wrapper
    ? createPortal(
        <Container
          tag="aside"
          height="100%"
          className={classNames('bottom-sheet', {
            'bottom-sheet--open': isOpen,
          })}
        >
          <div
            className={classNames('bottom-sheet__header', {
              'bottom-sheet__header--no-title': !title,
            })}
          >
            {title && <div className="bottom-sheet__header__title">{title}</div>}
            <CloseIcon role="button" className="icon" onClick={onClose} />
          </div>
          <div className="bottom-sheet__content">{children}</div>
          {actions && <div className="bottom-sheet__action">{actions}</div>}
        </Container>,
        wrapper
      )
    : null;
}
